import { Reducer } from 'redux'
import { IUserState, UserTypes } from './types'
import { createReducer } from 'reduxsauce'
import { failure, IActionType, IPaginator, ISearch, request, success } from '../root.types'
import User, { TypesUser } from '../../application/models/user/user'

export const INITIAL_STATE: IUserState = {
    create: {
        avatar: {},
        user: undefined,
        loading: false,
        success: false,
        error: false,
        loadingAvatar: false,
        dataError: {}
    },
    list: {
        users: [],
        loading: false,
        success: false,
        error: false,
        paginator: {
            first: 0,
            rows: 10,
            page: 0,
            pageCount: 0,
            totalRecords: 0,
            search: {
                key: '',
                value: ''
            }
        }
    },
    userLogged: {
        error: false,
        loading: false,
        success: false,
        userLogged: new User()
    },
}

export const resetCreate = (state: IUserState = INITIAL_STATE) => {
    return { ...state, create: INITIAL_STATE.create }
}
export const resetPaginator = (state: IUserState = INITIAL_STATE) => {
    const reset = {
        first: 0,
        rows: 10,
        page: 0,
        pageCount: 0,
        totalRecords: 0,
        search: {
            key: '',
            value: ''
        }

    }
    return {
        ...state,
        list: { ...state.list, paginator: reset }
    }
}
export const changeSearch = (
    state: IUserState = INITIAL_STATE,
    action: IActionType<{ search: ISearch }>) => {
    const { search } = action.payload
    return {
        ...state,
        list: {
            ...state.list,
            paginator: {
                ...state.list.paginator,
                search
            }
        }
    }
}
export const createUserRequest = (state: IUserState = INITIAL_STATE) => {
    return { ...state, create: request(state.create) }
}

export const createUserSuccess = (state: IUserState = INITIAL_STATE, action: IActionType<{ user }>) => {
    const { user } = action.payload
    const updateList = [user].concat(state.list.users)
    return {
        ...state,
        create: { ...state.create, user },
        list: success({ ...state.list, users: updateList })
    }
}

export const createUserFailure = (state: IUserState = INITIAL_STATE, action: IActionType<{ error }>) => {
    const dataError = action?.payload?.error || state.create.dataError
    return { ...state, create: failure({ ...state.create, dataError }) }
}

// reducers para procura usuario especifico
export const findUserRequest = (state: IUserState = INITIAL_STATE,
    action: IActionType<{ userId: string, typeUser: TypesUser }>) => {
    return { ...state, create: request({ ...state.create }) }
}
export const findUserSuccess = (
    state: IUserState = INITIAL_STATE,
    action: IActionType<{ data: any }>) => {
    const { data } = action.payload
    return {
        ...state,
        create: success({ ...state.create, user: data })
    }
}

export const findUserFailure = (state: IUserState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}

// reducers para atualizar dados do usuario
export const updateUserRequest = (state: IUserState = INITIAL_STATE, action: IActionType<{ user: any, avatar: any }>) => {
    return { ...state, create: request({ ...state.create }) }
}

export const updateUserSuccess = (state: IUserState = INITIAL_STATE,
    action: IActionType<{ data: any }>) => {
    const { data } = action.payload

    const updadedList = state.list.users.map((user) =>
        user.id === data.id ? data : user
    )
    return {
        ...state,
        create: success({ ...state.create, user: data }),
        list: { ...state.list, users: updadedList }
    }
}


export const updateUserFailure = (state: IUserState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}

// reducers para carregar listagem dos usuarios
export const loadUsers = (state: IUserState = INITIAL_STATE, action: IActionType<{ typeUser: TypesUser, paginator: IPaginator }>) => {
    const {  paginator } = action.payload
    return { ...state, list: request({ ...state.list, paginator }) }
}
export const loadUserSuccess = (
    state: IUserState = INITIAL_STATE,
    action: IActionType<{ data: any[], headers: any }>) => {
    const { data, headers } = action.payload
    const paginator = {
        ...state.list.paginator,
        totalRecords: parseInt(headers['x-total-count'], 10)
    }
    return {
        ...state,
        list: success({ ...state.list, users: data, paginator })
    }
}

export const loadUserFailure = (state: IUserState = INITIAL_STATE) => {
    return {
        ...state,
        list: failure(state.list)
    }
}

// reducers para remover usuario especifico
export const removeUserRequest = (state: IUserState = INITIAL_STATE, action: IActionType<{ user: any }>) => {
    return { ...state, list: request({ ...state.list }) }
}

export const removeUserSuccess = (state: IUserState = INITIAL_STATE,
    action: IActionType<{ userId: any }>) => {
    const { userId } = action.payload
    const updadedList = state.list.users?.filter((user: any) => userId !== user.id)
    const paginator = {
        ...state.list.paginator,
        totalRecords: state.list.paginator.totalRecords - 1
    }
    return {
        ...state,
        list: success({ ...state.list, users: updadedList, paginator })
    }
}

export const removeUserFailure = (state: IUserState = INITIAL_STATE) => {
    return {
        ...state,
        list: failure(state.list)
    }
}

// reducers para identificar os dados do usuario logado
export const getUserLoggedRequest = (state: IUserState = INITIAL_STATE) => {
    return { ...state, userLogged: request(state.userLogged) }
}

export const getUserLoggedSuccess = (
    state: IUserState = INITIAL_STATE,
    action: IActionType<{ userLogged: any }>) => {
    const { userLogged } = action.payload
    return { ...state, userLogged: success({ ...state.userLogged, userLogged }) }
}

export const getUserLoggedFailure = (state: IUserState = INITIAL_STATE) => {
    return { ...state, userLogged: failure(state.userLogged) }
}

// reducers para avatar

export const changeAvatarFile = (state: IUserState = INITIAL_STATE, action: IActionType<{ avatar: File }>) => {
    const { avatar } = action.payload
    return { ...state, create: { ...state.create, avatar: { ...state.create.avatar, file: avatar } } }
}

export const changeAvatarImg = (state: IUserState = INITIAL_STATE, action: IActionType<{ avatar: any }>) => {
    const { avatar } = action.payload
    return { ...state, create: { ...state.create, avatar: { ...state.create.avatar, img: avatar } } }
}

export const loadAvatarRequest = (state: IUserState = INITIAL_STATE) => {
    return { ...state, create: { ...state.create, loadingAvatar: true } }
}

export const loadAvatarSuccess = (state: IUserState = INITIAL_STATE) => {
    return { ...state, create: { ...state.create, loadingAvatar: false } }
}

export const loadAvatarFailure = (state: IUserState = INITIAL_STATE) => {
    return {
        ...state,
        create: {
            ...state.create,
            loadingAvatar: false,
            avatar: {
                file: '',
                img: ''
            }
        }
    }
}

export const removeAvatarRequest = (state: IUserState = INITIAL_STATE) => {
    return { ...state, create: { ...state.create, loadingAvatar: true } }
}

export const removeAvatarSuccess = (state: IUserState = INITIAL_STATE) => {
    return { ...state, create: { ...state.create, loadingAvatar: false, avatar: '' } }
}

export const removeAvatarFailure = (state: IUserState = INITIAL_STATE) => {
    return { ...state, create: { ...state.create, loadingAvatar: false } }
}

const reducer: Reducer<IUserState> = createReducer<IUserState>(INITIAL_STATE, {
    [UserTypes.RESET_CREATE]: resetCreate,
    [UserTypes.RESET_PAGINATOR]: resetPaginator,
    [UserTypes.CHANGE_SEARCH]: changeSearch,

    [UserTypes.CREATE_USER_REQUEST]: createUserRequest,
    [UserTypes.CREATE_USER_SUCCESS]: createUserSuccess,
    [UserTypes.CREATE_USER_FAILURE]: createUserFailure,

    [UserTypes.UPDATE_USER_REQUEST]: updateUserRequest,
    [UserTypes.UPDATE_USER_SUCCESS]: updateUserSuccess,
    [UserTypes.UPDATE_USER_FAILURE]: updateUserFailure,

    [UserTypes.FIND_USER_REQUEST]: findUserRequest,
    [UserTypes.FIND_USER_SUCCESS]: findUserSuccess,
    [UserTypes.FIND_USER_FAILURE]: findUserFailure,

    [UserTypes.LOAD_USER_REQUEST]: loadUsers,
    [UserTypes.LOAD_USER_SUCCESS]: loadUserSuccess,
    [UserTypes.LOAD_USER_FAILURE]: loadUserFailure,

    [UserTypes.REMOVE_USER_REQUEST]: removeUserRequest,
    [UserTypes.REMOVE_USER_SUCCESS]: removeUserSuccess,
    [UserTypes.REMOVE_USER_FAILURE]: removeUserFailure,

    [UserTypes.GET_USER_LOGGED_REQUEST]: getUserLoggedRequest,
    [UserTypes.GET_USER_LOGGED_SUCCESS]: getUserLoggedSuccess,
    [UserTypes.GET_USER_LOGGED_FAILURE]: getUserLoggedFailure,

    [UserTypes.CHANGE_AVATAR_FILE]: changeAvatarFile,
    [UserTypes.CHANGE_AVATAR_IMG]: changeAvatarImg,

    [UserTypes.LOAD_AVATAR_REQUEST]: loadAvatarRequest,
    [UserTypes.LOAD_AVATAR_SUCCESS]: loadAvatarSuccess,
    [UserTypes.LOAD_AVATAR_FAILURE]: loadAvatarFailure,

    [UserTypes.REMOVE_AVATAR_REQUEST]: removeAvatarRequest,
    [UserTypes.REMOVE_AVATAR_SUCCESS]: removeAvatarSuccess,
    [UserTypes.REMOVE_AVATAR_FAILURE]: removeAvatarFailure,
})
export default reducer
